module.exports = __webpack_public_path__ + "img/home-illustraition.9662e17a.png";